<template>
  <div :class="componentClasses" @click="clicked()">
    <svg
      width="20"
      height="13"
      viewBox="0 0 20 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0007 2.95845C8.04464 2.95845 6.45898 4.5441 6.45898 6.50011C6.45898 8.45612 8.04464 10.0418 10.0007 10.0418C11.9567 10.0418 13.5423 8.45612 13.5423 6.50011C13.5423 4.5441 11.9567 2.95845 10.0007 2.95845ZM7.29232 6.50011C7.29232 5.00434 8.50488 3.79178 10.0007 3.79178C11.4964 3.79178 12.709 5.00434 12.709 6.50011C12.709 7.99588 11.4964 9.20845 10.0007 9.20845C8.50488 9.20845 7.29232 7.99588 7.29232 6.50011Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0007 0.457733C6.73706 0.457733 4.44926 1.93043 2.98726 3.39259C2.25746 4.12247 1.73094 4.85163 1.38632 5.39902C1.21381 5.67304 1.08629 5.90246 1.00117 6.06496C0.958603 6.14625 0.926593 6.21088 0.904828 6.25609C0.893944 6.2787 0.885618 6.29646 0.879809 6.30902L0.872977 6.32393L0.870967 6.32839L0.870312 6.32985C0.870216 6.33007 0.869889 6.3308 1.25065 6.50001L0.869889 6.3308C0.822011 6.43854 0.822016 6.56152 0.869903 6.66925L1.25065 6.50001C0.869903 6.66925 0.869807 6.66903 0.869903 6.66925L0.870326 6.6702L0.870981 6.67166L0.872991 6.67612L0.879823 6.69103C0.885632 6.70359 0.893959 6.72134 0.904843 6.74395C0.926609 6.78915 0.958619 6.85377 1.00119 6.93504C1.08631 7.09751 1.21383 7.32688 1.38635 7.60084C1.73096 8.14812 2.25749 8.87712 2.98729 9.60685C4.4493 11.0687 6.73709 12.5411 10.0007 12.5411C13.2642 12.5411 15.552 11.0687 17.014 9.60685C17.7438 8.87712 18.2703 8.14812 18.615 7.60084C18.7875 7.32688 18.915 7.09751 19.0001 6.93504C19.0427 6.85377 19.0747 6.78915 19.0965 6.74395C19.1073 6.72134 19.1157 6.70359 19.1215 6.69103L19.1283 6.67612L19.1303 6.67166L19.131 6.6702C19.1311 6.66998 19.1314 6.66925 18.7507 6.50001L19.1314 6.66925C19.1793 6.56152 19.1793 6.43854 19.1314 6.3308L18.7507 6.50001C19.1314 6.3308 19.1315 6.33102 19.1314 6.3308L19.131 6.32985L19.1303 6.32839L19.1283 6.32393L19.1215 6.30902C19.1157 6.29646 19.1074 6.2787 19.0965 6.25609C19.0747 6.21088 19.0427 6.14625 19.0001 6.06496C18.915 5.90246 18.7875 5.67304 18.615 5.39902C18.2704 4.85163 17.7438 4.12247 17.014 3.39259C15.552 1.93043 13.2642 0.457733 10.0007 0.457733ZM1.73937 6.54833L1.71429 6.49999L1.73939 6.4516C1.8154 6.30646 1.93202 6.09638 2.09154 5.843C2.41099 5.33558 2.9001 4.65834 3.57655 3.98182C4.92704 2.63118 7.01424 1.29107 10.0007 1.29107C12.9871 1.29107 15.0743 2.63118 16.4248 3.98182C17.1012 4.65834 17.5903 5.33558 17.9098 5.843C18.0693 6.09638 18.1859 6.30646 18.2619 6.4516L18.287 6.49999L18.2619 6.54833C18.1859 6.69344 18.0693 6.90347 17.9098 7.1568C17.5903 7.6641 17.1012 8.34119 16.4248 9.01756C15.0743 10.3679 12.9871 11.7077 10.0007 11.7077C7.01421 11.7077 4.927 10.3679 3.57651 9.01756C2.90007 8.34119 2.41096 7.6641 2.09152 7.1568C1.932 6.90347 1.81539 6.69344 1.73937 6.54833Z"
        fill="black"
      />
    </svg>
  </div>
</template>

<script>
import iconMixin from '../../../mixins/component-mixins/root/iconMixin'

export default {
  name: 'IconEyeOpen',
  mixins: [iconMixin],
  computed: {
    componentClasses: function () {
      return {
        'rc-icon': true,
        'rc-icon-eye-open': true,
        ...this.componentSizeClasses,
        ...this.componentStateClasses
      }
    }
  }
}
</script>

<style scoped></style>
